import React from 'react';
import { OrdersToShipView } from './OrdersToShipView';

export const ShippingOrdersPrinting: React.FC = () => (
    <OrdersToShipView ordersWithAssignShipping />
);
